import { render, staticRenderFns } from "./PageShell.vue?vue&type=template&id=39251120"
import script from "./PageShell.vue?vue&type=script&lang=js"
export * from "./PageShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports